import React, { useEffect } from "react";
import "./confirm-dialog.scss";

const ConfirmDialog = ({
  open,
  title = "Delete",
  message,
  error = "",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  confirming = false,
  onCancel,
  onConfirm,
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape" && !confirming) onCancel?.();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, confirming, onCancel]);

  if (!open) return null;

  return (
    <div className="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
      <button
        type="button"
        className="confirm-dialog__backdrop"
        aria-label="Close"
        disabled={confirming}
        onClick={onCancel}
      />
      <div className="confirm-dialog__panel">
        <h3 id="confirm-dialog-title" className="confirm-dialog__title">
          {title}
        </h3>
        <p className="confirm-dialog__message">{message}</p>
        {error ? (
          <p className="confirm-dialog__error" role="alert">
            {error}
          </p>
        ) : null}
        <div className="confirm-dialog__actions">
          <button
            type="button"
            className="confirm-dialog__button"
            disabled={confirming}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="confirm-dialog__button confirm-dialog__button--danger"
            disabled={confirming}
            onClick={onConfirm}
          >
            {confirming ? "Deleting…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
